
<main class="choose-role-container">
    <h2>Sign in as</h2>
    <div class="roles-container">
        <button mat-flat-button class="roles signin-btn" *ngFor="let role of roleSvgArray" (click)="chooseRole(role)">
            <mat-icon [svgIcon]="role" class="user-type-icon"></mat-icon>
            <span class="role">{{getRole(role)}}</span>
        </button>
    </div>
</main>